<template>
    <button
        class="btn btn-light-success font-weight-bold mb-0"
        @click.stop.prevent="openViewProfileModal()"
    >
        View Profile
    </button>

    <modal
        @click.stop.prevent
        size="lg"
        class="text-left dm-modal dm-view-profile-modal"
        :id="'dm-view-profile-modal-' + editor.id"
        :title="editor.name"
    >
        <EditorProfile :editor="editor.modal_profile" />
    </modal>
</template>

<script>
import EditorProfile from "./EditorProfile.vue";

export default {
    components: { EditorProfile },

    props: ["editor"],

    data() {
        return {
            add_form_initialized: false,
        };
    },

    methods: {
        openViewProfileModal() {
            this.add_form_initialized = true;
            jQuery("#dm-view-profile-modal-" + this.editor.id).modal();
        },
    },
};
</script>
